<template>
  <div>
    <!-- 고객확인정보 화면 -->
    <div class="content-container">
      <!-- 상단 페이지명, 스텝 -->
      <div class="top-wrap" flex fjb>
        <div class="step-title">
          {{ $t("Verification.step3-1.checkUserInformation.title") }}
        </div>
        <div class="step-number" flex>
          <div class="number active">1</div>
          <div class="number active ml8">2</div>
          <div class="number active ml8">3</div>
          <div class="number ml8">4</div>
        </div>
      </div>
      <!-- //상단 페이지명, 스텝 -->
      <!-- 상단 안내문구 -->
      <top-noti :topcontent="topcontent" class="mt20"></top-noti>
      <!-- //상단 안내문구 -->

      <!-- 고객정보 확인 3-1 -->
      <div v-if="data.oneThird">
        <div class="content-title mt12">
          {{ $t("Verification.step3-1.basic") }}
        </div>
        <div class="content">
          <!-- 내/외국인 여부 -->
          <div class="item mt22">
            <div class="sub-title">
              {{ $t("Verification.step3-1.checkKorean") }}
            </div>
            <div class="detail">
              {{
                step2data.nationalInfo == "Y"
                  ? $t("Verification.step1.checkKorean.description[0]")
                  : $t("Verification.step1.checkKorean.description[1]")
              }}
            </div>
          </div>
          <!-- //내/외국인 여부 -->

          <!-- 국적 -->
          <div class="item">
            <div class="sub-title">
              {{ $t("Verification.step3-1.nationality") }}
            </div>
            <div class="detail">
              {{ step1data.nationality }}
            </div>
          </div>
          <!-- //국적 -->

          <!-- 국내거주 여부 -->
          <div class="item">
            <div class="sub-title">
              {{ $t("Verification.step3-1.checkKoreanResidence") }}
            </div>
            <div class="detail">
              {{
                step1data.domesticYn == "Y"
                  ? $t("Verification.step1.checkNationality.description[0]")
                  : $t("Verification.step1.checkNationality.description[1]")
              }}
            </div>
          </div>
          <!-- //국내거주 여부 -->

          <!-- 거주 국가 -->
          <div class="item">
            <div class="sub-title">
              {{ $t("Verification.step3-1.country") }}
            </div>
            <div class="detail">
              {{
                step1data.domesticYn == "Y"
                  ? "Republic of Korea/대한민국"
                  : step1data.selectedForeigner
                  ? step2cpndata.nationality
                  : "-"
              }}
            </div>
          </div>
          <!-- //거주 국가 -->

          <!-- 내국인/국내 거주 외국인/국내 비거주 외국인 분리 -->
          <!-- 내국인 -->
          <div v-if="step1data.selectedKorean">
            <step3-korean
              :data.sync="data"
              :step2data.sync="step2data"
              @tostep2="toStep2"
              @totowthird="toTowThird"
            ></step3-korean>
          </div>
          <!-- //내국인 -->

          <!-- 외국인 -->
          <div v-else-if="step1data.selectedForeigner">
            <!-- 국내 거주 -->
            <div v-if="step1data.domesticYn == 'Y'">
              <step3-foreigner-in-kr
                :data.sync="data"
                :step1data.sync="step1data"
                @tostep2="toStep2"
                @totowthird="toTowThird"
              ></step3-foreigner-in-kr>
            </div>
            <!-- //국내 거주 -->
            <!-- 국내 비거주 -->
            <div v-else>
              <step3-foreigner-in-others
                :data.sync="data"
                :cntlocalcode.sync="cntlocalcode"
                :step2cpndata.sync="step2cpndata"
                @tostep2="toStep2"
                @totowthird="toTowThird"
              ></step3-foreigner-in-others>
              <!-- //국내 비거주 -->
            </div>
          </div>

          <!-- //외국인 -->

          <!-- //내국인/국내 거주 외국인/국내 비거주 외국인 분리 -->
        </div>
      </div>
      <!-- //고객정보 확인 3-1 -->

      <!-- 고객정보 확인 3-2 -->
      <div v-else-if="data.twoThird">
        <div class="content-title mt12">
          {{ $t("Verification.step3-2.requiredInformation") }}
        </div>
        <div class="content">
          <!-- 직업 -->
          <div @click="openJobModal" class="item mt22">
            <div class="sub-title">
              {{ $t("Verification.step3-2.job.title") }}
            </div>
            <div class="detail dropdown" :class="{ change: data.changeBoxJ }">
              {{
                data.jobModalList == "0"
                  ? $t("Verification.step3-2.jobItems.default")
                  : data.jobModalList
              }}
            </div>
          </div>
          <!-- 거래목적 -->
          <div @click="openPurposeModal" class="item">
            <div class="sub-title">
              {{ $t("Verification.step3-2.purposeOfTransaction.title") }}
            </div>
            <div class="detail dropdown" :class="{ change: data.changeBoxP }">
              {{
                data.purposeList == "0"
                  ? $t(
                      "Verification.step3-2.purposeOfTransactionItems.default.title"
                    )
                  : data.purposeList
              }}
            </div>
          </div>
          <!-- //거래목적 -->

          <!-- 자금출처 -->
          <div @click="openSourceOfFundModal" class="item">
            <div class="sub-title">
              {{ $t("Verification.step3-2.SourceOfFunds.title") }}
            </div>
            <div class="detail dropdown" :class="{ change: data.changeBoxS }">
              {{
                data.sourceOfFundModalList == "0"
                  ? $t("Verification.step3-2.SourceOfFundsItems.default.title")
                  : data.sourceOfFundModalList
              }}
            </div>
          </div>
          <!-- //자금출처 -->

          <!-- 실제 소유자여부 -->
          <div @click="openRealOwnerModal" class="item">
            <div class="sub-title">
              {{ $t("Verification.step3-2.ownershipOfFunds.title") }}
            </div>
            <div
              class="detail dropdown"
              :class="{ change: data.changeBoxR, reject: data.changeBoxN }"
            >
              {{
                data.realOwnerModalList == 0
                  ? $t(
                      "Verification.step3-2.ownershipOfFundsItems.default.title"
                    )
                  : data.realOwnerModalList
              }}
            </div>
          </div>
          <!-- //실제 소유자여부출처 -->

          <!-- //직업 -->

          <!-- 가상자산 이용 서약서 -->
          <div class="item mt24">
            <div class="title">
              {{ $t("Verification.step3-2.oath.description") }}
              <span class="keycolor">{{
                $t("Verification.common.required")
              }}</span>
              <div class="button-wrap mt18" flex fjb>
                <el-checkbox
                  :label="$t('Verification.step1.privacyAgree')"
                  v-model="data.agreeChecked"
                  class="agree-checked"
                ></el-checkbox>
                <div class="detail-noti">
                  <a
                    :href="zendeskUrl[$i18n.locale]['acceptTransaction']"
                    style="margin: 0 0 0 0; padding: 0 0 0 0"
                    target="_blank"
                  >
                    {{ $t("Verification.step1.learnMore") }}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- //가상자산 이용 서약서 -->

          <div class="bottom-button-wrap bottom mt30" flex fjb>
            <button @click="toOneThird" class="next-button pre">
              {{ $t("Verification.common.pre") }}
            </button>
            <button
              @click="toThreeThird"
              :disabled="
                data.purposeList == '0' ||
                data.sourceOfFundModalList == '0' ||
                data.realOwnerModalList == '0' ||
                data.jobModalList == '0' ||
                data.agreeChecked == false
              "
              class="next-button next"
            >
              {{ $t("Verification.common.next") }}
            </button>
          </div>
        </div>
      </div>
      <!-- //고객정보 확인 3-2 -->

      <!-- 추가확인(직장인 or 전문직) 3-3 -->
      <div v-else-if="data.threeThird">
        <div class="content-title mt12">
          {{ $t("Verification.step3-3.additionalInformation") }}
        </div>
        <div class="content">
          <!-- 직장명-->
          <div class="item">
            <div class="sub-title">
              {{ $t("Verification.step3-3.companyName.title") }}
              <span class="keyColor">{{
                $t("Verification.common.required")
              }}</span>
            </div>
            <div class="authID input-box">
              <el-input
                type="text"
                maxlength="32"
                v-model="data.officeName"
                :placeholder="
                  $t('Verification.step3-3.companyName.description')
                "
                class="en-name mt8"
                :class="{ wrongData: data.officeName.length < 1 }"
              ></el-input>
              <div
                v-if="data.officeName.length < 1"
                class="sub keyColor mt4 fs10"
              >
                * {{ $t("Verification.step3-3.companyName.noti") }}
              </div>
            </div>
          </div>
          <!-- //직장명 -->

          <!-- 직장주소 -->
          <!-- 국내 비거주 외국인 -->
          <div v-if="step1data.selectedForeigner && step1data.liveInAnothers">
            <div class="item">
              <div class="sub-title">
                {{ $t("Verification.step3-3.companyAddress.title")
                }}<span class="keyColor">{{
                  $t("Verification.common.required")
                }}</span>
              </div>
              <div class="input-box authID">
                <el-input
                  type="number"
                  v-model="data.searchOfficeData.jobAddr1"
                  pattern="\d*"
                  :placeholder="
                    $t('Verification.step3-3.companyAddress.description')
                  "
                  class="en-name"
                />
                <el-input
                  type="text"
                  v-model="data.searchOfficeData.jobAddr2"
                  :placeholder="
                    $t('Verification.step3-3.companyAddress.description')
                  "
                  class="en-name mt8"
                />
                <el-input
                  type="text"
                  v-model="data.searchOfficeData.jobAddr3"
                  :placeholder="
                    $t('Verification.step3-3.companyAddress.description')
                  "
                  class="en-name mt8"
                />
              </div>
            </div>
          </div>
          <!-- //국내 비거주 외국인 -->
          <!-- 그 외 -->
          <div v-else>
            <search-page :searchdata.sync="data.searchOfficeData" />
          </div>
          <!-- //그 외 -->
          <!-- // 직장주소 -->

          <!-- 부서명-->
          <div class="item">
            <div class="sub-title">
              {{ $t("Verification.step3-3.department.title") }}
            </div>
            <div class="authID input-box">
              <el-input
                type="text"
                maxlength="16"
                v-model="data.officePart"
                :placeholder="$t('Verification.step3-3.department.description')"
                class="en-name mt8"
              ></el-input>
            </div>
          </div>
          <!-- //부서명 -->

          <!-- 직위-->
          <div class="item">
            <div class="sub-title">
              {{ $t("Verification.step3-3.spot.title") }}
            </div>
            <div class="authID input-box">
              <el-input
                type="text"
                maxlength="16"
                v-model="data.officeLevel"
                :placeholder="$t('Verification.step3-3.spot.description')"
                class="en-name mt8"
              ></el-input>
            </div>
          </div>
          <!-- //직위 -->

          <!-- 직장 연락처-->
          <div class="item">
            <div class="sub-title">
              {{ $t("Verification.step3-3.companyNumber.title") }}
            </div>
            <div class="authID input-box">
              <el-input
                v-model="data.officeNumber"
                type="number"
                pattern="\d*"
                :placeholder="
                  $t('Verification.step3-3.companyNumber.description')
                "
                @input="checkOfficeNumber(data.officeNumber)"
                class="en-name mt8"
              ></el-input>
              <div
                v-if="data.officeNumber.length > 12"
                class="sub keyColor mt4 fs10"
                :class="{
                  wrongData: data.officeNumber.length > 12,
                }"
              >
                * {{ $t("Verification.step3-3.companyNumber.noti") }}
              </div>
            </div>
          </div>
          <!-- //직장명 -->

          <div class="bottom-button-wrap bottom mt30" flex fjb>
            <button @click="toTowThird" class="next-button pre">
              {{ $t("Verification.common.pre") }}
            </button>
            <button
              @click="toStep4"
              :disabled="
                data.officeName.length < 1 || !data.searchOfficeData.addr1
              "
              class="next-button next"
            >
              {{ $t("Verification.common.next") }}
            </button>
          </div>
        </div>
      </div>
      <!-- //추가확인 3-3 -->

      <!-- 추가확인(개인사업자/자영업자) 3-4 -->
      <div v-else-if="data.fourThird">
        <div class="content-title mt12">
          {{ $t("Verification.step3-3.additionalInformation") }}
        </div>
        <div class="content">
          <!-- 업체명-->
          <div class="item">
            <div class="sub-title">
              {{ $t("Verification.step3-3.businessName.title") }}
              <span class="keyColor">{{
                $t("Verification.common.required")
              }}</span>
            </div>
            <div class="authID input-box">
              <el-input
                type="text"
                maxlength="32"
                v-model="data.indutyName"
                :placeholder="
                  $t('Verification.step3-3.businessName.description')
                "
                class="en-name mt8"
                :class="{ wrongData: data.indutyName.length < 1 }"
              ></el-input>
              <div
                v-if="data.indutyName.length < 1"
                class="sub keyColor mt4 fs10"
              >
                * {{ $t("Verification.step3-3.businessName.noti") }}
              </div>
            </div>
          </div>
          <!-- //업체명 -->

          <!-- 직장주소 -->
          <!-- 국내 비거주 외국인 -->
          <div v-if="step1data.selectedForeigner && step1data.liveInAnothers">
            <div class="item">
              <div class="sub-title">
                {{ $t("Verification.step3-3.businessAddress.title") }}
                <span class="keyColor">{{
                  $t("Verification.common.required")
                }}</span>
              </div>
              <div class="input-box authID">
                <el-input
                  type="number"
                  v-model="data.searchPersonalData.addr1"
                  pattern="\d*"
                  :placeholder="
                    $t('Verification.step3-3.businessAddress.description')
                  "
                  class="en-name"
                />
                <el-input
                  type="text"
                  v-model="data.searchPersonalData.addr2"
                  :placeholder="
                    $t('Verification.step3-3.businessAddress.description')
                  "
                  class="en-name mt8"
                />
                <el-input
                  type="text"
                  v-model="data.searchPersonalData.addr3"
                  :placeholder="
                    $t('Verification.step3-3.businessAddress.description')
                  "
                  class="en-name mt8"
                />
              </div>
            </div>
          </div>
          <!-- //국내 비거주 외국인 -->
          <!-- 그 외 -->
          <div v-else>
            <search-page :searchdata.sync="data.searchPersonalData" />
          </div>
          <!-- //그 외 -->
          <!-- // 직장주소 -->

          <!-- 사업자등록번호-->
          <div class="item">
            <div class="sub-title">
              {{ $t("Verification.step3-3.businessNumber.title") }}
              <span class="keyColor">{{
                $t("Verification.common.required")
              }}</span>
            </div>
            <div class="authID input-box">
              <el-input
                v-model="data.bizIdNumber"
                type="number"
                pattern="\d*"
                :placeholder="
                  $t('Verification.step3-3.businessNumber.description')
                "
                class="en-name mt8"
                :class="{
                  wrongData:
                    data.bizIdNumber.length < 8 || data.bizIdNumber.length > 14,
                }"
              ></el-input>
              <div
                v-if="
                  data.bizIdNumber.length < 8 || data.bizIdNumber.length > 14
                "
                class="sub keyColor mt4 fs10"
              >
                * {{ $t("Verification.step3-3.businessNumber.noti") }}
              </div>
            </div>
          </div>
          <!-- //사업자등록번호 -->

          <!-- 업종명-->
          <div class="item">
            <div class="sub-title">
              {{ $t("Verification.step3-3.businessType.title") }}
              <span class="keyColor">{{
                $t("Verification.common.required")
              }}</span>
            </div>
            <div class="detail">
              {{ data.jobModalList }}
            </div>
          </div>
          <!-- //업종명 -->

          <!-- 설립일자 -->
          <div class="item">
            <div class="sub-title">
              {{ $t("Verification.step3-3.businessCreated.title") }}
            </div>
            <div class="authID input-box">
              <el-date-picker
                v-model="data.foundDate"
                type="date"
                :placeholder="
                  $t('Verification.step3-3.businessCreated.description')
                "
                class="idcard-start"
              ></el-date-picker>
            </div>
          </div>
          <!-- //설립일자 -->

          <!-- 연락처 -->
          <div class="item">
            <div class="sub-title">
              {{ $t("Verification.step3-3.businessContact.title") }}
            </div>
            <div class="authID input-box">
              <el-input
                v-model="data.bizNumber"
                type="number"
                pattern="\d*"
                :placeholder="
                  $t('Verification.step3-3.businessContact.description')
                "
                @input="checkBizNumber(data.officeNumber)"
                class="en-name mt8"
              ></el-input>
              <div
                v-if="data.bizNumber.length < 8 || data.bizNumber.length > 12"
                class="sub keyColor mt4 fs10"
              >
                * {{ $t("Verification.step3-3.businessContact.noti") }}
                {{ "* " }}
              </div>
            </div>
          </div>
          <!-- //설립일자 -->

          <div class="bottom-button-wrap bottom mt30" flex fjb>
            <button @click="toTowThird" class="next-button pre">
              {{ $t("Verification.common.pre") }}
            </button>
            <button
              @click="toStep4"
              :disabled="
                data.indutyName.length < 1 ||
                data.bizIdNumber.length < 8 ||
                !data.searchPersonalData.addr1
              "
              class="next-button next"
            >
              {{ $t("Verification.common.next") }}
            </button>
          </div>
        </div>
      </div>
      <!-- //추가확인 3-4 -->
    </div>
    <!-- //고객확인정보 화면 -->

    <!-- 성별 팝업 -->
    <el-dialog
      :visible.sync="data.genderModal"
      :title="$t('Verification.step3-1.gender.title')"
      :close-on-click-modal="false"
      class="authID-modal"
    >
      <el-radio-group v-model="data.genderList" @change="changeGenderModal">
        <ul class="dropdown-list">
          <li v-for="(item, index) in data.genderItems" :key="index">
            <el-radio :label="item.gender"></el-radio>
          </li>
        </ul>
      </el-radio-group>
    </el-dialog>
    <!-- //성별 팝업 -->

    <!-- 거래목적 팝업 -->
    <el-dialog
      :visible.sync="data.purposeModal"
      :title="
        $t('Verification.step3-2.purposeOfTransactionItems.default.title')
      "
      :close-on-click-modal="false"
      class="authID-modal"
    >
      <el-radio-group v-model="data.purposeList" @change="changePurposeModal">
        <ul class="dropdown-list">
          {{
            data.purposeItems
          }}
          <li v-for="(item, index) in data.purposeItems" :key="index">
            <el-radio
              :label="getSelectItems(item, 'purposeOfTransactionItems')"
            ></el-radio>
          </li>
        </ul>
      </el-radio-group>
    </el-dialog>
    <!-- //거래목적 팝업 -->

    <!-- 자금출처 팝업 -->
    <el-dialog
      :visible.sync="data.sourceOfFundModal"
      :title="$t('Verification.step3-2.SourceOfFundsItems.default.title')"
      :close-on-click-modal="false"
      class="authID-modal"
    >
      <el-radio-group
        v-model="data.sourceOfFundModalList"
        @change="changesourceOfFundModal"
      >
        <ul class="dropdown-list">
          <li v-for="(item, index) in data.sourceOfFundItems" :key="index">
            <el-radio
              :label="getSelectItems(item, 'SourceOfFundsItems')"
              style="display: flex; align-items: center"
            >
              <div>
                <!-- {{ getSelectItems(item, "SourceOfFundsItems") }} -->
                {{
                  $t(
                    `Verification.step3-2['SourceOfFundsItems']['${item.code}'].title`
                  )
                }}
                <div class="dropdown-list-description">
                  {{
                    $t(
                      `Verification.step3-2['SourceOfFundsItems']['${item.code}'].desc`
                    )
                  }}
                </div>
              </div>
            </el-radio>
          </li>
        </ul>
      </el-radio-group>
    </el-dialog>
    <!-- //자금출처 팝업 -->

    <!-- 실제 소유자여부 팝업 -->
    <el-dialog
      :visible.sync="data.realOwnerModal"
      :title="$t('Verification.step3-2.ownershipOfFundsItems.default.title')"
      :close-on-click-modal="false"
      class="authID-modal"
    >
      <el-radio-group
        v-model="data.realOwnerModalList"
        @change="changerealOwnerModal"
      >
        <ul class="dropdown-list">
          <li
            v-for="(item, index) in data.realOwnerItem"
            :key="index"
            @change="noRealOwnerModal"
          >
            <el-radio
              :label="getSelectItems(item, 'ownershipOfFundsItems')"
            ></el-radio>
          </li>
        </ul>
      </el-radio-group>
    </el-dialog>
    <!-- //실제 소유자여부 팝업 -->

    <!-- 직업 팝업 -->
    <el-dialog
      :visible.sync="data.jobModal"
      :title="$t('Verification.step3-2.jobItems.default')"
      :close-on-click-modal="false"
      class="authID-modal"
    >
      <ul class="dropdown-list">
        <li v-for="(item, index) in data.jobItem" :key="index">
          <!-- type: 1. 직장인 -->
          <div v-if="item.title == '직장인'">
            <div
              @click="data.clickOfficeWorker = !data.clickOfficeWorker"
              class="list-item-title"
            >
              <span
                class="arrow"
                :class="{ open: data.clickOfficeWorker }"
              ></span>
              {{ getSelectItems(item, "jobItems") }}
            </div>
            <ul v-if="data.clickOfficeWorker">
              <li
                v-for="(list, index) in item.category"
                :key="index"
                class="two-depth"
              >
                <el-radio-group
                  v-model="data.jobModalList"
                  @change="
                    changeJobModalModal(item.type, list.danger, list.code)
                  "
                >
                  <el-radio
                    :label="getSelectItems(item, 'jobItems', list.code)"
                  ></el-radio>
                </el-radio-group>
              </li>
            </ul>
          </div>
          <!-- // type: 1. 직장인 -->

          <!-- type: 1. 전문직 -->
          <div v-else-if="item.title == '전문직'">
            <div
              @click="data.clickProfessional = !data.clickProfessional"
              class="list-item-title"
            >
              <span
                class="arrow"
                :class="{ open: data.clickProfessional }"
              ></span>
              {{ getSelectItems(item, "jobItems") }}
            </div>
            <ul v-if="data.clickProfessional">
              <li
                v-for="(list, index) in item.category"
                :key="index"
                class="two-depth"
              >
                <el-radio-group
                  v-model="data.jobModalList"
                  @change="
                    changeJobModalModal(item.type, list.danger, list.code)
                  "
                >
                  <el-radio
                    :label="getSelectItems(item, 'jobItems', list.code)"
                  ></el-radio>
                </el-radio-group>
              </li>
            </ul>
          </div>
          <!-- // type: 1. 전문직 -->

          <!-- 그 외 type: 1 -->
          <div v-else-if="item.type == 1">
            <el-radio-group
              v-model="data.jobModalList"
              @change="changeJobModalModal(item.type, 'Y', item.code)"
            >
              <el-radio :label="getSelectItems(item, 'jobItems')"></el-radio>
            </el-radio-group>
          </div>
          <!-- // 그 외 type: 1 -->

          <!-- type: 2 -->
          <div v-else-if="item.type == 2">
            <div
              @click="data.clickPrivateBusiness = !data.clickPrivateBusiness"
              class="list-item-title"
            >
              <span
                class="arrow"
                :class="{ open: data.clickPrivateBusiness }"
              ></span>
              {{ getSelectItems(item, "jobItems") }}
            </div>
            <ul v-if="data.clickPrivateBusiness">
              <li
                v-for="(list, index) in item.category"
                :key="index"
                class="two-depth"
              >
                <el-radio-group
                  v-model="data.jobModalList"
                  @change="
                    changeJobModalModal(item.type, list.danger, list.code)
                  "
                >
                  <el-radio
                    :label="getSelectItems(item, 'jobItems', list.code)"
                  ></el-radio>
                </el-radio-group>
              </li>
            </ul>
          </div>
          <!-- // type: 2 -->

          <!-- type: 0 -->
          <div v-else>
            <el-radio-group
              v-model="data.jobModalList"
              @change="changeJobModalModal(item.type, null, item.code)"
            >
              <el-radio :label="getSelectItems(item, 'jobItems')"></el-radio>
            </el-radio-group>
          </div>
          <!-- // type: 0 -->
        </li>
      </ul>
    </el-dialog>
    <!-- //직업 팝업 -->

    <!-- 실제 소유자 아님 시 안내 팝업 -->
    <vs-popup
      :title="$t('notify.type.info')"
      :active.sync="data.notiModal"
      class="small-popup"
      :button-close-hidden="true"
    >
      <div class="text-wrap">
        <div class="text-detail">
          <p class="center" v-html="$t('Verification.step3-2.notOwner')"></p>
        </div>
      </div>
      <div class="button-wrap">
        <button @click="closeNotiModal">
          {{ $t("confirm.ok") }}
        </button>
      </div>
    </vs-popup>
    <!-- // 실제 소유자 아님 시 안내 팝업 -->
  </div>
</template>
<script>
import topNoti from "../../authIdentity/top-noti.vue";
import searchPage from "./search.vue";
import Api from "@/common/Api";
import step3Korean from "./step3-1korean.vue";
import step3ForeignerInKr from "./step3-1foreigner-inKR.vue";
import step3ForeignerInOthers from "./step3-1foreigner-inOthers.vue";
import { mapState } from "vuex";

export default {
  props: {
    data: {
      oneThird: Boolean, //고객정보 확인 3-1
      twoThird: Boolean, //고객정보 확인 3-2
      threeThird: Boolean, //추가정보. 직장인 or 전문직
      fourThird: Boolean, //추가정보. 개인사업자/자영업자
      Address: Boolean, //주소검색
      purposeModal: Boolean, //거래목적 선택 팝업
      sourceOfFundModal: Boolean, //자금출처 선택 팝업
      realOwnerModal: Boolean, //실제 소유자 여부 선택 팝업
      jobModal: Boolean, //직업 선택 팝업
      purposeList: String, //거래목적 선택 list v-model
      purposeCode: String, //거래목적 코드
      sourceOfFundModalList: String, //자금출처 선택 list v-model
      realOwnerModalList: String, //실제 소유자 여부 선택 list v-model
      jobModalList: String, //직업 선택 list v-model
      changeBoxP: Boolean, //거래목적 리스트 라디오 버튼 클릭 시 스타일 변경
      changeBoxS: Boolean, //자금출처 리스트 라디오 버튼 클릭 시 스타일 변경
      changeBoxR: Boolean, //실제 소유자 맞음 선택 시 스타일 변경
      changeBoxN: Boolean, //실제 소유자 아님 선택 시 스타일 변경
      changeBoxJ: Boolean, //직업 리스트 라디오 버튼 클릭 시 스타일 변경
      notiModal: Boolean, //실제 소유자 아님 시 안내 팝업
      clickOfficeWorker: Boolean, //직장 > 직장인 리스트 선택
      clickProfessional: Boolean, //직장 > 전문직 리스트 선택
      clickPrivateBusiness: Boolean, //직장 > 개인사업자/자영업자 리스트 선택
      agreeChecked: Boolean, //동의합니다 체크박스
      enSurname: String, //3-1 영문 성
      enGivenName: String, //3-1 영문 이름
      address: String, //3-1 주소
      personalCode: String, //주민등록번호 뒤 7자리
      officeName: String, //3-3 직장이름(직장인/전문직->고위험군)
      officePart: String, //3-3 직장부서명(직장인/전문직->고위험군)
      officeLevel: String, //3-3 직장직위(직장인/전문직->고위험군)
      officeNumber: String, //3-3 직장연락처(직장인/전문직->고위험군)
      // officeAddress: String, //3-3 직장주소
      searchAddress: String, //주소 입력값
      addressResult1: String, //도로명주소
      addressResult2: String, //지번주소
      zoneNo: Number, //우편번호
      result: Boolean, //주소 검색 결과
      purposeItems: Array, //거래목적 선택 data
      sourceOfFundItems: Array, //자금출처 선택 data
      sourceOfFundCode: String, //자금출처 선택 code
      realOwnerItem: Array, //실제 소유자 여부 선택 data
      jobItem: Array, //직업 선택 data
      jobCode: String, //직업 선택 code
      clickedJobType: String, //선택된 job type
      indutyName: String, //업체명(개인사업자/자영업자->고위험군)
      induty: String, //업종명(개인사업자/자영업자->고위험군)
      bizIdNumber: String, //사업자등록번호(개인사업자/자영업자->고위험군)
      foundDate: String, //설립일자(개인사업자/자영업자->고위험군)
      bizNumber: String, //사업장연락처(개인사업자/자영업자->고위험군)
      // 기본정보 주소
      searchData: {
        addr1: String,
        addr2: String,
        addr3: String,
      },
      // 직장인/전문직 직장 주소
      searchOfficeData: {
        addr1: String,
        addr2: String,
        addr3: String,
      },
      // 개인사업자/자영업 업체 주소
      searchPersonalData: {
        addr1: String,
        addr2: String,
        addr3: String,
      },
      activeBtn: Boolean, // 주민번호 유효성 검사에 따른 다음 버튼 활성화
      idCardStartDate: String, //외국인등록증발급일자
      idCardEndDate: String, //외국인등록증만료일자
      genderModal: Boolean, //성별 선택 팝업
      genderList: String, //성별 선택 list v-model
      genderItems: Array, //성별 선택 data
      passportNumber: String, //여권 번호
      foreignerbirth: String, //외국인 국내 비거주 생년월일
      jobCategory: String, // job category(api 호출용)
      riskCountryResult: String, // 위험국가 여부
    },
    cntlocalcode: String, //통신사 국가 코드
    step1data: {
      nation: String, // 국적 확인
      selectedKorean: Boolean, // 내국인 선택
      selectedForeigner: Boolean, // 외국인 선택
      domesticYn: String, //국내 거주
      liveInAnothers: Boolean, //국내 비거주
      // 외국인
      foreigner: {
        // 국내 거주 외국인
        birthDate: String, // 생년월일
        mobileNo: String, // 휴대폰 번호
      },
      selectedCountryCode: "", // (외국인) 선택 국적 2자 영문 코드
    },
    step2data: {
      name: String, //이름
      birth: String, //생년월일
      gender: String, //성별
      nationality: String, //내국인 여부
      mobileNumber: String, //휴대폰 번호
      ci: String, //ci
      di: String, //di
      image: String, //신분증 이미지
      driverLicenseNo: String, //운전면허 번호
      serialNo: String, //식별 번호
    },
    step2cpndata: {
      enSurname: String, // 영문 성
      enGivenName: String, // 영문 이름
      nationality: String, // 통신사 국가 확인
      cntLocalCode: String, // 선택한 통신사 국가 번호
      personalCode: String, // 휴대폰 번호
    },
  },
  components: {
    topNoti,
    searchPage,
    step3Korean,
    step3ForeignerInKr,
    step3ForeignerInOthers,
  },
  async created() {
    // this.toTowThird(); // test
    window.scrollTo(0, 0);
  },
  data() {
    return {
      addressLists: "",
      massage: "",
      topcontent: this.$t(
        "Verification.step3-1.checkUserInformation.description"
      ),
    };
  },
  computed: {
    ...mapState("Firebase", ["zendeskUrl"]),
    birth() {
      if (this.step1data.selectedKorean) {
        return this.step2data.birth.slice(2);
      } else {
        return this.step1data.foreigner.birthDate.slice(2);
      }
    },
  },
  methods: {
    /*
    data: type,
    type: 필수정보 카테고리(거래목적, 자금 출처, 실제 소유자 여부, 직업),
    list: 최종 code
     */
    getSelectItems(data, type, list = null) {
      if (list) {
        // 항목 추가로 인해 다국어 파일에 내용 없을 때
        if (
          !this.$t(
            `Verification.step3-2['${type}']['${data.code}'].detail`
          ).hasOwnProperty(list)
        ) {
          const result = data.category.find((ele) => ele.code === list);
          return result.title;
          // 내용 있을 때
        } else {
          return this.$t(
            `Verification.step3-2['${type}']['${data.code}'].detail['${list}']`
          );
        }
      } else {
        // 항목 추가로 다국어 파일에 내용 없을 때
        if (
          !this.$t(
            `Verification.step3-2['${type}']['${data.code}'].title`
          ).hasOwnProperty(data.code)
        ) {
          return data.title;
        } else {
          // 내용 있을 때
          return this.$t(
            `Verification.step3-2['${type}']['${data.code}'].title`
          );
        }
      }
    },
    //step2로 이동
    toStep2() {
      this.$emit("tostep2");
    },
    // 3-1로 이동
    toOneThird() {
      window.scrollTo(0, 0);
      this.data.oneThird = true;
      this.data.twoThird = false;
    },
    // 3-2로 이동
    async toTowThird() {
      window.scrollTo(0, 0);
      const res = await Api.getJobData();
      this.data.purposeItems = res.data.result.data.trade_pur; // 거래목적 선택 data
      this.data.sourceOfFundItems = res.data.result.data.capi_origin; // 자금출처 선택 data
      this.data.realOwnerItem = res.data.result.data.r_owner_yn; // 실제 소유자 여부 선택 data
      this.data.jobItem = res.data.result.data.job; // 직업 선택 data
      // 페이지 이동
      this.data.oneThird = false;
      this.data.twoThird = true;
      this.data.threeThird = false;

      // 추가정보 데이터 리셋 - 직장인, 전문직
      (this.data.jobModalList = "0"), // 업종명
        (this.data.officeName = ""), // 직장명
        (this.data.officePart = ""), // 부서명
        (this.data.officeLevel = ""), // 직위
        (this.data.officeNumber = ""), // 연락처
        (this.data.searchOfficeData.addr1 = ""), // 우편번호
        (this.data.searchOfficeData.addr2 = ""), // 주소
        (this.data.searchOfficeData.addr3 = ""), // 상세 주소
        // 추가정보 데이터 리셋 - 개인사업자, 자영업자
        (this.data.indutyName = ""), // 업체명
        (this.data.bizIdNumber = ""), // 사업자등록번호
        (this.data.jobModalList = "0"), // 업종명
        (this.data.foundDate = ""), // 설립일자
        (this.data.bizNumber = ""), // 연락처
        (this.data.searchPersonalData.addr1 = ""), // 우편번호
        (this.data.searchPersonalData.addr2 = ""), // 주소
        (this.data.searchPersonalData.addr3 = ""), // 상세 주소
        (this.data.changeBoxJ = false);
    },
    // 이전 버튼 클릭 시 3-2로 이동
    // backToTowThird() {
    //   // 추가정보 데이터 리셋 - 직장인, 전문직
    //   this.data.jobModalList = "0", // 업종명
    //   this.data.officeName = "", // 직장명
    //   this.data.officePart = "", // 부서명
    //   this.data.officeLevel = "", // 직위
    //   this.data.officeNumber = "", // 연락처
    //   this.data.searchOfficeData.jobAddr1 = "", // 우편번호
    //   this.data.searchOfficeData.jobAddr2 = "", // 주소
    //   this.data.searchOfficeData.jobAddr3 = "", // 상세 주소

    //   // 추가정보 데이터 리셋 - 개인사업자, 자영업자
    //   this.data.indutyName = "", // 업체명
    //   this.data.bizIdNumber = "", // 사업자등록번호
    //   this.data.jobModalList = "0", // 업종명
    //   this.data.foundDate = "", // 설립일자
    //   this.data.bizNumber = "", // 연락처
    //   this.data.searchPersonalData.bizAddr1 = "", // 우편번호
    //   this.data.searchPersonalData.bizAddr2 = "", // 주소
    //   this.data.searchPersonalData.bizAddr3 = "", // 상세 주소
    //   this.data.changeBoxJ = false

    //   // 페이지 이동
    //   this.data.oneThird = false;
    //   this.data.twoThird = true;
    //   this.data.threeThird = false;
    // },
    // 3-3로 이동
    async toThreeThird() {
      window.scrollTo(0, 0);
      /* 새로운 코드는 여기부터 */

      // 내/외국인 추가정보 조건식 새로 정렬
      const foriegnerYn = this.step1data.selectedForeigner; // 외국인
      const jobType = this.data.clickedJobType; // job type
      const danger = this.data.clickedJobDanger; // dangerYn
      const riskCountryCode = this.step1data.selectedCountryCode; // 위험국가 2자 영문 코드
      const riskCountry =
        riskCountryCode == "" ? "" : await Api.getRiskCountry(riskCountryCode); // 위험국가 판단 api
      this.data.riskCountryResult =
        riskCountry == "" ? false : riskCountry.data.result; // 위험국가 여부
      const riskCountryResult = this.data.riskCountryResult;
      // let jobCategory = this.data.jobCategory; // job category(api 호출용)
      this.data.twoThird = false;
      this.data.threeThird = false;
      this.data.fourThird = false;

      // 외국인 위험국가, 국내 비거주(내/외국인 통합)
      if (
        (foriegnerYn == "Y" && riskCountryResult == "Y") ||
        this.step1data.liveInAnothers == true
      ) {
        if (jobType == "0") {
          // jobType : 0
          switch (this.data.jobCode) {
            case "06001": // 자유직, 프리랜서
            case "20001": // 전업주부
            case "30001": // 학생, 군인
            case "40001": // 무직
              this.data.jobCategory = "0";
              this.$emit("tostep4");
              break;
            default:
              this.data.jobCategory = "1";
              this.data.threeThird = true;
              break;
          }
        } else if (jobType == "1") {
          // jobType : 1
          this.data.jobCategory = "1";
          this.data.threeThird = true;
        } else if (jobType == "2") {
          // jobType : 2
          this.data.jobCategory = "2";
          this.data.fourThird = true;
        }
      } else {
        // 내국인, 외국인 !위험국가
        // 국내 거주
        if (this.step1data.domesticYn == "Y") {
          if (jobType == 0) {
            // job type 0
            this.data.jobCategory = "0";
            this.$emit("tostep4");
          } else if (jobType == 1) {
            // job type 1
            if (danger == "Y") {
              // danger
              this.data.jobCategory = "1";
              this.data.threeThird = true;
            } else {
              // !danger
              this.data.jobCategory = "0";
              this.$emit("tostep4");
            }
          } else if (jobType == 2) {
            // job type 2
            if (danger == "Y") {
              // danger
              this.data.jobCategory = "2";
              this.data.fourThird = true;
            } else {
              // !danger
              this.data.jobCategory = "0";
              this.$emit("tostep4");
            }
          }
        }
      }
      /* 새로운 코드는 여기까지 */
    },
    // step4로 이동
    toStep4() {
      this.$emit("tostep4");
    },

    // 거래목적 선택 팝업
    openPurposeModal() {
      this.data.purposeModal = true;
    },
    // 자금출처 선택 팝업
    openSourceOfFundModal() {
      this.data.sourceOfFundModal = true;
    },
    // 실제소유 선택 팝업
    openRealOwnerModal() {
      this.data.realOwnerModal = true;
    },
    // 직업 선택 팝업
    openJobModal() {
      this.data.jobModal = true;
    },
    // 직업 라디오 버튼 선택 시
    changeJobModalModal(type, danger, code) {
      // 전문직에서도 예외 처리
      if (code == "03002" || code == "03005" || code == "03006") {
        this.data.purposeCode = "";
        this.data.sourceOfFundCode = "";
        this.data.purposeList = "0";
        this.data.sourceOfFundModalList = "0";
        this.data.changeBoxS = false;
        this.data.changeBoxP = false;
      } else {
        // 직군별 거래목적, 자금출처 자동 세팅
        switch (code.slice(0, 2)) {
          case "01":
          case "02":
          case "03":
          case "04":
            this.data.purposeCode = "A0202";
            this.data.sourceOfFundCode = "A0301";

            break;
          case "05":
            this.data.purposeCode = "A0202";
            this.data.sourceOfFundCode = "A0303";
            break;
          case "20":
          case "30":
            this.data.purposeCode = "A0202";
            this.data.sourceOfFundCode = "A0308";
            break;

          default:
            this.data.purposeCode = "";
            this.data.sourceOfFundCode = "";
            this.data.purposeList = "0";
            this.data.sourceOfFundModalList = "0";
            this.data.changeBoxS = false;
            this.data.changeBoxP = false;
            break;
        }
      }

      if (this.data.purposeCode) {
        const purposeCode = _.find(
          this.data.purposeItems,
          (ele) => ele.code == this.data.purposeCode
        );
        this.data.purposeList = purposeCode.title;
        this.data.changeBoxS = true;
        this.data.changeBoxP = true;
      }
      if (this.data.sourceOfFundCode) {
        const sourceOfFundCode = _.find(
          this.data.sourceOfFundItems,
          (ele) => ele.code == this.data.sourceOfFundCode
        );
        this.data.sourceOfFundModalList = sourceOfFundCode.title;
        this.data.changeBoxS = true;
        this.data.changeBoxP = true;
      }

      this.data.clickedJobType = type;
      this.data.clickedJobDanger = danger;
      this.data.jobCode = code;
      this.data.jobModal = false; //팝업 닫힘
      this.data.changeBoxJ = true; //스타일 변경
    },
    // 거래목적 라디오 버튼 선택 시
    changePurposeModal() {
      this.data.purposeModal = false; //팝업 닫힘
      this.data.changeBoxP = true; //스타일 변경
      const purposeCode = _.find(
        this.data.purposeItems,
        (ele) => ele.title == this.data.purposeList
      );
      this.data.purposeCode = purposeCode.code; //선택한 거래목적 코드
    },
    // 자금출처 라디오 버튼 선택 시
    changesourceOfFundModal() {
      this.data.sourceOfFundModal = false; //팝업 닫힘
      this.data.changeBoxS = true; //스타일 변경

      const sourceOfFundCode = _.find(
        this.data.sourceOfFundItems,
        (ele) => ele.title == this.data.sourceOfFundModalList
      );
      this.data.sourceOfFundCode = sourceOfFundCode.code; //선택한 거래목적 코드
    },
    // 실제 소유자 여부 라디오 버튼 선택 시
    changerealOwnerModal() {
      this.data.realOwnerModal = false; //팝업 닫힘
      this.data.changeBoxR = true; //스타일 변경
      this.data.changeBoxN = false; //스타일 변경
    },

    // 실제 소유자 아님 선택 시
    noRealOwnerModal() {
      if (this.data.realOwnerModalList == "실제 소유자 아님") {
        this.data.realOwnerModal = false; //팝업 닫힘
        this.data.notiModal = true;
      }
    },
    // 실제 소유자 아님 팝업 확인 선택 시
    closeNotiModal() {
      this.data.changeBoxN = true; //스타일 변경
      this.data.changeBoxR = false; //스타일 변경
      this.data.notiModal = false;
    },
    //
    jobCategoryDepth2() {},
    // 주소검색 버튼 클릭
    clickSearchAddress() {
      this.data.oneThird = false;
      this.data.Address = true;
    },
    // 직장주소검색 버튼 클릭
    clickSearchOfficAddress() {
      this.data.threeThird = false;
      this.data.Address = true;
    },
    //휴대폰 번호 "-" 삽입
    mobilePhone(phoneNumber) {
      const phoneNumberArray = phoneNumber.split("");
      phoneNumberArray.splice(3, 0, "-");
      phoneNumberArray.splice(-4, 0, "-");
      const joinNumber = phoneNumberArray.join("");
      return joinNumber;
    },
    // //성별 선택 모달
    // openGenderModal() {
    //   this.data.genderModal = true;
    // },
    // //
    changeGenderModal() {
      this.data.genderModal = false; //팝업 닫힘
    },
    // 직장연락처 유효성 검사
    checkOfficeNumber(number) {
      this.step3data.officeNumber = number.slice(0, 12);
    },
    // 개인사업자 연락처 유효성 검사
    checkBizNumber(number) {
      this.step3data.bizNumber = number.slice(0, 12);
    },
  },
};
</script>
<style lang="scss" scoped>
.defaultColor {
  color: #333;
}
.keyColor {
  color: #eb3246;
}
.content-container {
  .result {
    .item-box {
      border-bottom: 1px solid #afafaf;
    }
  }
}
.authID-container {
  .title-wrap {
    position: relative;
    padding: 7px 0;
    border-bottom: 1px solid #eef0f3;
    .title {
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      color: #222222;
    }
    .close-button {
      position: absolute;
      top: 3px;
      right: 12px;
    }
  }
  .step {
    .top-wrap {
      .step-title {
        font-size: 14px;
        font-weight: 500;
      }
    }
    .content-title {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.29;
      color: #333;
    }
    .content {
      .item {
        margin-top: 12px;
        .sub-title {
          margin-bottom: 8px;
          /* font-size: 12px; */
          font-weight: normal;
          line-height: 1.5;
          color: #333;
        }
        .authID {
          .search-address {
            width: 62px;
            padding: 10px 0px 11px;
            font-size: 12px;
            color: #333;
            border: 1px solid #dcdfe3;
            border-radius: 0 2px 2px 0;
            background-color: #fff;
          }
          .one-fifth {
            width: calc(100% - 62px);
            border: 1px solid #dcdfe3;
            border-right: 0 solid;
            border-right: 0;
            border-radius: 2px 0 0 2px;
          }
        }
        .detail {
          padding: 11px 0 11px 8px;
          border-radius: 2px;
          border: solid 1px #dcdfe3;
          background-color: #f7f8fa;
          &.full-box {
            height: 38px;
            color: #333;
            background-color: #fff;
          }
          &.dropdown {
            position: relative;
            color: #afafaf;
            background-color: #fff;
            &:after {
              content: "";
              position: absolute;
              top: 13px;
              right: 9px;
              width: 6.7px;
              height: 12px;
              background-image: url("../../../../../../assets/img/mypage/button_arrow_right_icon.svg");
              background-size: 6.7px 12px;
              background-repeat: no-repeat;
            }
            &.selected {
              color: #333;
              border: solid 1px #00b473;
              background-color: #f2fbf8;
            }
            &.change {
              color: #333;
              border: solid 1px #00b473;
              background-color: #f2fbf8;
            }
            &.reject {
              color: #333;
              border: solid 1px #eb3246;
              background-color: #fff;
            }
          }
        }
        .input-box {
          .en-name.half {
            width: calc((100% - 12px) / 2);
          }
        }
      }
    }
  }
  // 하단 버튼
  button.next-button {
    width: 100%;
    padding: 10px 0;
    /* font-size: 12px; */
    border-radius: 2px;
    border: 1px solid #00b473;
    background-color: #00b473;
    &.pre {
      width: 96px;
      color: #333;
      border: 1px solid #eeeeee;
      background-color: #fff;
      &:disabled {
        border: solid 1px #dadada !important;
        background-color: #dadada !important;
      }
    }
    &.next {
      width: calc(100% - 104px);
    }
    &.bottom {
      position: absolute;
      bottom: 32px;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% - 24px);
    }
    &:disabled {
      border: solid 1px #dadada !important;
      background-color: #dadada !important;
    }
  }
  .button-wrap {
    position: relative;
    &.select-box {
      button.default {
        padding: 10px 9px;
      }
    }
    .detail-noti {
      color: #afafaf;
    }
  }
  .bottom-button-wrap {
    width: 100%;
  }
}
// step number
.step-number {
  .number {
    width: 20px;
    height: 20px;
    text-align: center;
    color: #dcdfe3;
    border-radius: 2px;
    background-color: #f7f8fa;
    &.active {
      color: #fff;
      background-color: #333;
    }
  }
}
.dropdown-list {
  list-style: none;
  li {
    padding: 20px 12px;
    font-size: 12px;
    font-weight: 500;
    &.padding-change {
      padding: 11px 12px;
    }
    .detail {
      padding-left: 27px;
      margin-bottom: 2px;
      font-size: 10px;
      font-weight: normal;
      line-height: 1.8;
      color: #999;
    }
    .list-item-title {
      position: relative;
      padding-left: 20px;
      .arrow {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-left: 5px solid #333;
        border-top: 5px solid transparent;
        border-bottom: 5px solid transparent;
        &.open {
          width: 0;
          height: 0;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-top: 6px solid #333;
          border-bottom: 0;
        }
      }
    }

    ul {
      list-style: none;
    }
  }

  &-description {
    font-size: 10px;
    color: #999;
    margin-top: 5px;
    font-weight: normal;
  }
}
</style>
